import { render } from "./SeriesPodcast.vue?vue&type=template&id=6872300c&scoped=true"
import script from "./SeriesPodcast.vue?vue&type=script&lang=js"
export * from "./SeriesPodcast.vue?vue&type=script&lang=js"

import "./SeriesPodcast.vue?vue&type=style&index=0&id=6872300c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6872300c"]])

export default __exports__